import React, { useEffect, useState } from 'react'

import { SectionSubtitle } from '../../../..'
import { useStudents } from '../../../../../context'
import { getRoutinesNames } from '../../../../../firebase/utils/routines'
import { Spacer } from '../../../../global'
import MPlayer from '../../../../musicPlayer/MPlayer'

export interface Routines {
  category: string
  content: {
    title: string
    url: string
    routine: string
    logUID: string
    visibility: boolean
  }[]
}

const RoutineSection = () => {
  const { studentLogs } = useStudents()
  const [exerByCat, setExerByCat] = useState<Routines[] | null>(null)

  useEffect(() => {
    studentLogs && getRoutinesNames(studentLogs, setExerByCat)
  }, [studentLogs])

  console.log('exerByCat', exerByCat)

  return (
    <>
      <SectionSubtitle
        children="Rutina de entrenamiento"
        fontSize={18}
        fontWeight={500}
      />
      <Spacer height={23} />
      {/* {exerByCat && <RoutinesAccordion items={exerByCat} type="primary" />} */}
      {exerByCat && <MPlayer routines={exerByCat} />}
    </>
  )
}

export default RoutineSection
